import { IRouteConfig, IRouteConfigWithComponent, PermissionKeys } from '../shared';
import { ReportPage } from './pages/report/report.page';
import { ReportsPage } from './pages/reports/reports.page';

export const reportsRoutes: IRouteConfig[] = [
    { path: '/reports/*', component: ReportsPage, requiredPermissions: PermissionKeys.REPORTS_READ },
];

export const reportSubRoutes: IRouteConfigWithComponent[] = [{ path: '/:id', component: ReportPage }];
